/* eslint-disable @typescript-eslint/no-unused-vars */

import { Injectable } from '@angular/core';

import {
    CanActivate, ActivatedRouteSnapshot,
    RouterStateSnapshot, Router
} from '@angular/router';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {AuthService} from "./auth.service";

/**
 * @description Guard che monitora lo stato di autenticazione
 * di un utente sull'applicazione
 */
@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isUserAuthenticatedObservable
      .pipe(
        take(1),
        map((isAuthenticated: boolean) => {
          if (!isAuthenticated) {
              this.router.navigate(['/signin']).catch(console.log);
              return false;
          }
          return true;
        })
      )
  }
}
